export class Gatsby {
    public static isRuntime(): boolean {
        return typeof window !== 'undefined'
    }
    
    public static isCompileTime(): boolean {
        return typeof window === 'undefined'
    }
}
